var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgC4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 46,
    viewBox: "0 0 118 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "parcelforce"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M118 0H0V40.8707H118V0Z",
    fill: "#E50012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M118 40.8281H0V45.3646H118V40.8281Z",
    fill: "#004A97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88.1324 35.7487C83.1755 33.7745 77.9665 32.1783 72.5475 30.9182C77.0844 31.2962 82.7974 32.0103 88.9726 34.1105C89.0986 34.3625 89.1406 34.5726 89.0986 34.6986C89.0146 35.0766 88.6785 35.4127 88.1324 35.7487ZM83.5956 37.0088C79.8149 34.7826 75.9501 32.8924 72.0434 31.2962C77.4624 32.5143 82.6294 34.1105 87.5443 36.0427C86.6201 36.4628 85.2339 36.7988 83.5956 37.0088ZM77.5464 37.2189C75.32 34.9926 73.0096 33.0184 70.6992 31.2962C74.7739 32.8924 78.8067 34.7826 82.7134 37.0509C81.2431 37.2189 79.4788 37.3029 77.5464 37.2189ZM71.2453 36.6308C70.6992 34.5726 70.1111 32.7244 69.4809 31.0442C71.9594 32.7664 74.4379 34.8246 76.8323 37.1769C75.068 37.0929 73.2196 36.9248 71.2453 36.6308ZM67.8846 36.0007C66.8344 35.7907 65.8263 35.5387 64.8181 35.2866C66.2043 33.5645 67.5486 32.0943 68.8088 30.8341C69.4809 32.5143 70.027 34.4045 70.6152 36.5468C69.733 36.3788 68.8508 36.2108 67.8846 36.0007ZM64.272 35.1186C62.3816 34.6146 60.6593 34.0265 59.021 33.3964C62.1716 32.2203 65.2382 31.3382 68.1787 30.7501C66.9605 32.0103 65.5742 33.4804 64.272 35.1186ZM53.686 30.9602C58.1388 30.4981 62.5496 30.3301 66.9185 30.5401C64.1039 31.1702 61.2474 32.0103 58.3069 33.1444C56.5845 32.4303 55.0302 31.7162 53.686 30.9602ZM49.9053 28.1878C55.1143 28.3979 60.3652 28.9859 65.6582 29.994C61.4995 29.868 57.2146 30.0781 52.9719 30.5401C51.6276 29.7 50.5774 28.9019 49.9053 28.1878ZM35.8327 34.0265C34.8665 32.4303 34.4464 30.8341 34.7825 29.406C34.8245 29.196 34.9085 28.9859 35.0345 28.7339C39.6974 28.1878 44.4443 27.9778 49.2752 28.1038C49.8633 28.8599 50.8715 29.7 52.2157 30.5821C46.7127 31.2962 41.2517 32.4303 35.8327 34.0265ZM20.3738 31.1702C21.1299 30.5821 22.1381 29.9941 23.4824 29.532C27.6831 28.1878 31.9679 27.1377 36.3368 26.3816C35.6226 26.9277 34.9925 27.6418 34.6144 28.3138C29.7835 28.9019 24.9946 29.826 20.3738 31.1702ZM19.1135 31.5062C17.3072 32.0523 15.5429 32.6404 13.7786 33.2704C15.8789 32.3043 17.9793 31.4222 20.1217 30.6661C19.7017 30.9602 19.3656 31.2122 19.1135 31.5062ZM45.4104 25.3315C46.4606 25.3735 47.6369 25.4575 48.8971 25.6255C48.7291 25.7936 48.603 26.0036 48.561 26.2136C48.477 26.6337 48.603 27.1377 48.8971 27.6838C44.3182 27.5578 39.7814 27.7678 35.3286 28.2719C35.9167 27.3477 36.8409 26.4236 37.9331 26.1716C40.3695 25.7516 42.89 25.4575 45.4104 25.3315ZM49.0231 26.2976C49.0651 26.1296 49.2332 25.9196 49.5272 25.7096C54.5261 26.4236 60.4493 27.9358 64.9441 29.322C59.7771 28.3979 54.6102 27.8098 49.4852 27.6838C49.4432 27.6418 49.4012 27.5998 49.3592 27.5578C49.0651 27.0537 48.9391 26.6337 49.0231 26.2976ZM51.0815 25.1215C53.1819 25.1215 55.3243 25.2055 57.4247 25.3315C60.4072 26.0876 63.8939 27.5998 66.9605 29.406C62.4656 27.9358 55.8704 26.1296 50.2413 25.2895C50.4934 25.2475 50.7874 25.1635 51.0815 25.1215ZM66.6664 26.4656C67.2965 27.3897 67.9687 28.8179 68.3467 29.7C65.6582 27.9778 62.5917 26.5077 59.7351 25.5415C62.0456 25.7516 64.356 26.0876 66.6664 26.4656ZM69.649 27.0537C70.4051 27.2217 71.2033 27.3897 71.9594 27.5578C70.8672 28.3559 69.565 29.448 69.0189 29.952C68.7248 29.28 68.0107 27.7258 67.3385 26.5917C68.0947 26.7177 68.8928 26.8857 69.649 27.0537ZM79.1847 29.574C76.2862 29.322 72.9676 29.49 69.733 29.994C70.4471 29.364 71.6653 28.3139 72.6315 27.7258C74.8159 28.2718 77.0424 28.9019 79.1847 29.574ZM87.1242 32.5983C87.6283 32.8504 88.0484 33.1024 88.3425 33.3544C81.7892 31.2122 75.8241 30.6661 71.2453 30.2881C74.7739 29.826 78.3026 29.784 81.2431 30.2461C83.2175 30.9602 85.1499 31.7582 87.1242 32.5983ZM97.5422 37.933C99.0545 38.8571 100.567 39.8232 102.037 40.8313H102.919C92.9633 33.8585 81.8732 29.0699 69.775 26.5497C54.4421 23.3573 38.7732 24.1974 24.1965 28.7339C24.0285 28.7759 23.8604 28.8599 23.6924 28.9019C18.3574 30.6241 13.1904 32.8084 8.23352 35.4967C8.23352 35.4967 8.23352 35.4967 8.19151 35.4967C5.41899 37.0088 2.68849 38.647 0.0419922 40.4952V40.8313H0.46207C3.02455 39.0671 5.71305 37.4289 8.40155 35.9587C11.6782 34.4886 15.0808 33.2704 18.5254 32.2203C17.8533 33.1024 17.5593 34.0265 17.3492 34.9506C16.9711 36.7988 17.1392 38.7731 17.8953 40.8733H18.5674C17.7693 38.8151 17.6013 36.8828 17.9793 35.1186C18.1894 34.1105 18.6095 32.9764 19.5756 31.9263C24.4065 30.4981 29.3635 29.49 34.3624 28.8599C34.2784 29.0279 34.2364 29.196 34.1944 29.322C33.8583 30.8762 34.2364 32.5143 35.2446 34.2365C29.5735 35.9587 23.9865 38.185 18.5674 40.8733H19.7017C24.8686 38.395 30.1616 36.2948 35.4966 34.6986C36.8409 36.7568 39.0673 38.8571 42.0918 40.8733H43.184C39.9074 38.7731 37.471 36.6308 36.0847 34.5306C41.6297 32.8924 47.2588 31.7582 52.8458 31.0862C54.1901 31.8843 55.7864 32.6824 57.6347 33.4384C52.9299 35.2866 48.0569 37.7649 43.226 40.8733H44.2342C48.9811 37.891 53.728 35.4967 58.3489 33.7325C60.0712 34.4046 61.9195 35.0346 63.9779 35.6227C62.7177 37.2189 61.3734 38.9831 60.0712 40.9153H60.8693C62.1716 39.0251 63.3478 37.3449 64.566 35.7907C65.6162 36.0847 66.7084 36.3368 67.8426 36.5888C68.8508 36.7988 69.817 36.9668 70.8252 37.1349C71.1192 38.311 71.3713 39.6131 71.6653 40.9153H72.3795C72.1274 39.6131 71.7074 38.395 71.4133 37.2189C73.4717 37.5129 75.4881 37.7229 77.3784 37.8069C78.3866 38.815 79.3528 39.8652 80.319 40.9573H80.9911C80.0249 39.8652 79.0587 38.8151 78.0925 37.8489C80.0669 37.8909 81.9153 37.8489 83.5116 37.6389C85.2759 38.689 86.9982 39.7812 88.7625 40.9573H89.6447C87.8804 39.7392 86.116 38.605 84.3097 37.5129C85.948 37.2609 87.2923 36.8828 88.2164 36.3788C91.5771 37.7229 94.8117 39.2351 97.9202 40.9153H98.9704C95.6938 39.1091 92.2492 37.4709 88.7205 36.0427C89.1826 35.7067 89.4767 35.2866 89.6027 34.8666C89.6447 34.7406 89.6447 34.5726 89.6027 34.4045C91.535 35.0766 93.5094 35.9167 95.4838 36.9248C95.4418 36.7988 97.0801 37.6809 97.5422 37.933Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.3646 12.646L25.6668 10.4198H26.4228C26.4228 10.4198 27.0529 10.4618 26.9269 11.0919C26.8849 11.2179 26.8009 11.4279 26.7169 11.5959C26.4649 12.058 25.9188 12.478 25.4567 12.604C25.4147 12.604 25.4147 12.604 25.3727 12.604C24.9527 12.6881 24.3646 12.646 24.3646 12.646ZM23.8606 13.5282C23.8606 13.5282 24.9107 13.5701 25.5828 13.4021C26.2968 13.1921 27.1789 12.52 27.557 11.806C27.683 11.5539 28.019 10.9238 27.809 10.2518C27.599 9.45368 26.8009 9.5377 26.8009 9.5377L25.0367 9.6217L21.5503 15.5864L22.5164 15.6284H22.6424L23.8606 13.5282Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M88.1746 25.7933L88.2166 25.4993L87.2925 25.3732L86.6204 25.3312L86.9984 21.8448L87.0404 21.5088L86.2843 21.4668L85.7383 26.0033L86.4524 26.0453L88.1326 26.2133L88.1746 25.7933Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M72.0431 12.3101C72.6312 10.3359 74.1014 9.03371 76.4536 8.9497C77.9238 8.90769 78.7219 9.62177 79.0999 10.5039C79.478 11.386 79.436 12.4361 79.2679 13.1082C79.0159 14.0323 77.9658 16.1325 74.9835 16.2165C74.1854 16.2585 73.4293 16.0905 72.8832 15.6705C72.0011 15.1244 71.5391 14.0323 72.0431 12.3101ZM74.9415 18.1487C79.688 17.7707 80.9901 15.2504 81.5362 12.6461C81.7462 11.68 81.5782 10.5879 81.1162 9.66377C80.4021 8.31962 78.9319 7.31151 76.6216 7.39552C74.6054 7.47953 73.0512 8.36162 72.0011 9.41174C71.6651 9.70577 71.4131 10.0418 71.161 10.3359C70.699 10.9659 70.4049 11.596 70.2369 12.016C70.1529 12.2681 70.1109 12.4781 70.0689 12.6881C69.9429 13.2762 69.9009 13.7802 69.9009 14.2423C69.9429 15.4604 70.4889 16.3845 71.203 17.0146C72.2531 17.8967 73.6813 18.2328 74.9415 18.1487Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M66.5405 13.2321H69.4808L69.6068 12.686L69.9009 11.6779H68.2207H66.9605L67.5906 9.40964L70.783 9.28363L70.909 8.90559L71.161 7.85547L66.1204 8.02349L64.5662 13.5261L64.4822 13.8621L63.4741 17.4746L64.6923 17.5166L65.3223 17.5586L66.5405 13.2321Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M48.9808 9.53541L49.3168 8.69531L47.8887 8.73732L47.5106 9.61941L47.0486 10.7956L46.2505 12.6438L45.7464 13.8199L44.8223 16.0882L44.6123 16.6342H45.1584L45.7884 16.6762L48.8968 16.8022L49.1068 16.2562L49.4008 15.4161L47.9307 15.3321L46.7546 15.2901L48.9808 9.53541Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M44.3182 16.0471L44.6542 15.249L43.226 15.207L42.1339 15.165L43.142 12.9808H45.2843L45.4103 12.6447L45.7463 11.8046H44.7382H43.6041L44.4022 9.99842L46.7544 9.91441L46.8805 9.62037L47.2585 8.73828L43.4781 8.9063L40.0757 16.4252L40.7478 16.4672H41.1678L44.1081 16.5932L44.3182 16.0471Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M39.8233 16.0905L39.9073 15.9224L40.4533 14.6203C39.2772 15.2084 38.5211 15.2504 38.0591 15.0823C37.555 14.9143 37.345 14.4943 37.303 14.2003C37.177 13.6962 37.513 12.7721 38.1431 11.89C38.3531 11.596 38.6471 11.3019 38.9412 11.0079L38.9832 10.9659C39.0672 10.8819 39.1512 10.7979 39.2352 10.7138C39.4032 10.5878 39.5292 10.5038 39.6553 10.4198C41.2934 9.45371 42.3016 10.6718 42.3016 10.6718L42.7216 9.74774L42.8896 9.3697C42.5536 8.86565 40.2433 8.27758 38.1431 10.1678C37.9331 10.3778 37.723 10.5878 37.513 10.8399C36.7569 11.764 36.0848 12.9401 35.9168 13.9062C35.8748 14.2002 35.8328 14.4943 35.8748 14.7463C36.0428 15.5864 36.4209 16.0485 36.8829 16.3005C38.0591 16.9306 39.8233 16.0905 39.8233 16.0905Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M52.5096 12.854L52.4256 12.686L54.1898 11.2578L49.0232 12.56L48.2671 12.728L48.8552 12.938L50.2413 13.4L53.1816 14.4082L52.5096 12.854Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M58.0126 10.6719L58.0546 10.2939L58.8107 4.03516L55.0303 10.5459L56.9625 9.03372L57.1725 9.32776L57.6766 10.1259L58.0126 10.6719Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M55.5762 15.6262L54.6101 16.3403L54.274 16.5923L54.19 16.4663L53.56 15.2062L53.3919 14.8281L53.3499 15.1222L52.2578 22.0529L53.686 19.6167L56.5003 14.9541L55.5762 15.6262Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M64.2712 12.729L58.9366 11.2589L58.6006 11.1748L58.2225 11.0488L59.1886 12.771L58.3485 13.4851L57.0464 14.5352L57.8445 14.3252L60.0287 13.7791L62.885 13.0651L64.2712 12.729Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M102.121 17.518L102.163 19.1982H102.415L103.213 19.2402L110.354 19.5762L110.312 18.6941L110.228 17.35L105.86 17.1819L104.809 17.1399L104.725 13.5695L109.388 13.6115L109.262 11.5113H104.599L104.557 8.57096L109.304 8.44495L109.262 7.77287L109.178 6.38672L102.037 6.63875V8.57096L102.079 10.7552L102.121 17.518Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M55.2822 12.4351L56.3743 10.6289L53.9801 12.4771L53.686 12.6871L55.2822 12.4351Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M29.4052 13.1076H28.103L30.0353 10.7553L29.4052 13.1076ZM31.0854 10.0832L31.2534 9.36914L29.9933 9.41114L28.5231 11.1753L26.1708 14.0737L26.0868 14.1577L24.7847 15.7539L25.8768 15.7959H26.0028L27.347 14.0737L29.1532 14.1577L28.9851 14.8298L28.7331 15.9639L29.4892 16.0059H29.8672L31.0854 10.0832Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M33.8586 12.6039C33.3125 12.7299 32.8505 12.6879 32.8085 12.6459L34.0686 10.2516L35.0767 10.2096C35.6648 10.2936 35.7488 10.5876 35.7068 10.9657C35.6228 11.3437 35.3708 11.7638 35.2028 11.9318C34.7827 12.3518 34.2787 12.5198 33.8586 12.6039ZM34.0266 13.57C36.0009 13.2759 36.6309 11.7218 36.7989 11.1757C36.967 10.7136 36.967 10.3356 36.883 10.0836C36.6729 9.15946 35.4548 9.20146 35.4548 9.20146L33.3966 9.28548L29.9102 15.9642L30.5402 16.0062H30.9183H31.0443L32.7665 12.6879L33.4806 16.1323H33.9846L34.7827 16.1743L34.0266 13.57Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M90.7791 14.3671C90.9891 15.3752 91.5772 16.3413 92.4173 17.1814C94.3495 19.0716 97.7099 20.1218 101.322 18.4416V17.8955V16.0053C100.776 16.3833 99.3061 16.9714 97.9619 16.9714C96.6178 17.0134 95.3996 16.5934 94.4755 15.8373C93.6354 15.1232 93.0894 14.1151 92.9213 12.897C92.6693 10.7547 95.0636 9.07451 96.0717 8.78047C99.138 7.89837 101.196 9.49456 101.196 9.49456V8.31843V7.31031C100.86 7.05828 98.634 6.55423 97.1218 6.63824C96.2397 6.68024 93.1314 7.26831 91.5772 9.7886C90.9891 10.7547 90.6111 11.9728 90.6531 13.569C90.6531 13.8631 90.6951 14.1151 90.7791 14.3671Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M81.1592 18.2315L82.7974 18.3155L83.3854 18.3575L84.6036 9.03242C84.6036 9.03242 86.1157 8.94842 86.8298 8.94842C87.3759 8.94842 88.048 9.36846 88.258 10.1245C88.3 10.3346 88.342 10.5866 88.3 10.8386C88.048 12.1408 86.7878 12.6448 85.7377 12.8129C84.8976 12.9389 84.1415 12.8969 84.1415 12.8969L85.4437 14.8711L87.8799 18.5255L88.594 18.5675L90.6523 18.6515L87.4179 14.241C89.1401 13.5689 90.3162 12.6448 90.5262 11.1327C90.6943 9.95653 90.4842 9.15843 90.1062 8.57037C89.1401 7.05819 87.0819 7.18421 87.0819 7.18421L82.6714 7.35223L81.4112 16.4253L81.1592 18.2315Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M110.901 28.2272L110.859 27.6811L109.01 27.5131L108.296 27.4291L108.212 25.8329L110.648 26.043L110.606 25.7909V25.2449L108.884 25.1189L108.17 25.0348L108.086 23.6487L110.69 23.8167V23.5647L110.648 23.0186L107.246 22.8086L107.456 28.2272L108.212 28.2692L110.943 28.5632L110.901 28.2272Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M103.171 26.9691L103.129 23.3567H103.255C104.179 23.3987 104.683 23.5667 105.061 23.9028C105.145 23.9868 105.229 24.0708 105.313 24.1548C105.523 24.4068 105.649 24.7849 105.691 25.2889C105.733 26.003 105.481 26.3811 105.103 26.6751C104.935 26.8011 104.641 27.0111 103.927 27.0531C103.759 27.0531 103.549 27.0531 103.339 27.0111C103.339 26.9691 103.255 26.9691 103.171 26.9691ZM106.448 25.3729C106.448 24.4908 106.154 23.8608 105.733 23.4407C105.103 22.8107 104.137 22.6006 103.465 22.5586L102.247 22.4746L102.289 27.6832L103.045 27.7672L103.381 27.8092C104.515 27.8932 106.448 27.5152 106.448 25.3729Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M101.239 22.8937V22.3897L100.441 22.3477V27.4722L101.155 27.5562H101.281L101.239 22.8937Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M76.7477 20.794L75.9076 20.752L75.1095 22.3062L74.7735 22.9363L74.3534 21.3401L74.1434 20.5L73.0513 22.3062L72.6732 22.9783L72.2112 20.752L72.1692 20.542L71.4131 20.5L72.3372 24.6165L73.8494 22.2642L74.5214 24.8685L76.5797 21.0881L76.7477 20.794Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M77.5887 24.1123C77.3366 23.8182 77.2526 23.4822 77.3366 23.1041C77.4206 22.6841 77.5887 22.3481 77.9247 22.096C78.2607 21.802 78.6388 21.676 79.0588 21.676C79.4369 21.676 79.7309 21.802 79.9409 22.012C79.9829 22.054 80.0249 22.054 80.0249 22.096C80.277 22.3901 80.361 22.7261 80.277 23.1462C80.235 23.5662 80.0249 23.9022 79.6889 24.1543C79.3529 24.4063 78.9748 24.5323 78.5548 24.5323C78.4288 24.5323 78.3027 24.4903 78.2187 24.4903C78.0087 24.4483 77.7987 24.3223 77.5887 24.1123ZM80.235 24.7423C80.739 24.3643 81.033 23.8182 81.0751 23.2302C81.1591 22.6421 80.991 22.096 80.613 21.676C80.529 21.592 80.445 21.508 80.361 21.424C80.0249 21.1299 79.6049 21.0039 79.1428 21.0039C78.5548 21.0039 78.0087 21.2139 77.5046 21.592C77.0006 22.012 76.7066 22.4741 76.5805 23.0621C76.4965 23.6502 76.6225 24.1963 77.0006 24.6163C77.2106 24.8683 77.4626 25.0364 77.7987 25.1204C78.0087 25.2044 78.2607 25.2464 78.5128 25.2464C79.1428 25.2884 79.7309 25.1204 80.235 24.7423Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M83.8474 24.1122C84.4774 23.9862 84.8555 23.5242 84.9395 22.8101C84.9815 22.348 84.8975 22.012 84.6455 21.7179C84.3934 21.4239 84.0154 21.2559 83.5113 21.2559L82.1252 21.1719L81.5791 25.5824L82.1672 25.6244H82.3352L82.8392 21.928L83.5953 21.97C83.8894 21.97 84.0994 22.096 84.1834 22.348C84.2254 22.474 84.2674 22.6 84.2254 22.7681C84.1414 23.2721 83.6373 23.3981 83.2173 23.3981C82.9233 23.3981 82.6712 23.3561 82.6712 23.3561L83.1333 24.1542L84.0154 25.7504L84.3514 25.7924L84.9395 25.8344L83.8474 24.1122Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M90.0648 22.4309H90.3168C90.8209 22.4729 91.493 22.5569 91.913 23.019C92.123 23.271 92.2911 23.649 92.2491 24.1531C92.123 25.4132 91.325 25.6653 90.4849 25.6233C90.3588 25.6233 90.1908 25.6233 90.0648 25.5813L89.8128 25.5393L90.0648 22.4309ZM92.9631 24.2791C93.0472 23.397 92.7531 22.8089 92.3331 22.4309C91.787 21.9268 91.0309 21.7588 90.4008 21.7168L89.3087 21.6328L88.8887 26.2953L89.5608 26.3794L89.8968 26.4214C91.0729 26.5474 92.7951 26.3794 92.9631 24.2791Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M99.516 22.3068L98.7179 22.2648L97.8358 24.533L97.5418 25.1631L96.7437 22.8528L96.4077 21.9707L95.1055 24.9531L94.2654 22.3908L94.1394 21.9707L93.2993 21.8867L94.9795 26.9693L95.2735 26.3392L96.3237 23.8609L96.7017 24.9531L97.4998 27.2633L97.7518 26.5913L99.348 22.7688L99.516 22.3068Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M54.9462 14.4098L55.2822 12.4355L53.686 12.6876L53.8961 13.1496L54.8622 14.9558L54.9462 14.4098Z",
    fill: "#9EABD3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M55.9548 12.5611L57.635 12.8552L57.0049 11.721L56.5849 11.0069L56.3748 10.6709V10.6289L55.2827 12.4351L55.9548 12.5611Z",
    fill: "#9EABD3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2537_1007",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 46
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4__29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M118 0.00195312H0V45.4091H118V0.00195312Z",
    fill: "white"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2537_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M55.2824 12.4355L54.9463 14.4098L54.8623 14.9558L55.1143 14.7458L57.6346 12.8556L55.9544 12.5616L55.2824 12.4355Z",
    fill: "#004A97"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4);
export default __webpack_public_path__ + "static/media/c4.60e50e83ad95b2cc9a930e0243c6fc7a.svg";
export { ForwardRef as ReactComponent };